/*
 * @prettier
 * @copyright (c) 2019 - present, HGC-AB
 * @licence This source code is licensed under the MIT license described and found in the
 * LICENSE file in the root directory of this source tree.
 */
import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
import MuiLink from '@material-ui/core/Link'
import Tab from '@material-ui/core/Tab'

/**
 * Material ui Links for Gatsby
 * @type {React.ForwardRefExoticComponent<React.PropsWithoutRef<{}> & React.RefAttributes<unknown>>}
 */
const Link = React.forwardRef((props, ref) => {
  return <MuiLink component={GatsbyLink} ref={ref} underline='none' color="textPrimary" {...props} />
})

/**
 * Custom Links to be used in Tabs
 * @type {React.ForwardRefExoticComponent<React.PropsWithoutRef<{}> & React.RefAttributes<unknown>>}
 */
export const TabLink = React.forwardRef((props, ref) => {
  return <Tab component={GatsbyLink} color="testPrimary" ref={ref} {...props} />
})

export default Link
